import React from 'react';
import { Helmet } from 'react-helmet-async';
import PageHeader from '../../PageHeader';
import CorporateSectionLayout from '../../CorporateSectionLayout';
import DewanKomisaris from './DewanKomisaris';
import Direksi from './Direksi';
import StrukturOrganisasi from './StrukturOrganisasi';

function ManajemenLayout() {
    const items = [
        { id: 'dewan-komisaris', number: '01', label: 'Dewan Komisaris', content: <DewanKomisaris />, surface: false },
        { id: 'direksi', number: '02', label: 'Direksi', content: <Direksi />, surface: false },
        { id: 'struktur-organisasi', number: '03', label: 'Struktur Organisasi', content: <StrukturOrganisasi />, surface: false },
    ];

    return (
        <>
            <Helmet>
                <title>Manajemen | PT Len Telekomunikasi Indonesia</title>
                <meta name="description" content="Struktur manajemen PT Len Telekomunikasi Indonesia meliputi dewan komisaris, direksi, dan struktur organisasi." />
                <link rel="canonical" href="https://www.len-telko.co.id/manajemen" />
                <meta property="og:title" content="Manajemen | PT Len Telekomunikasi Indonesia" />
                <meta property="og:description" content="Informasi manajemen PT LTI: dewan komisaris, direksi, dan struktur organisasi." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://www.len-telko.co.id/manajemen" />
                <meta property="og:image" content="https://www.len-telko.co.id/logo512.png" />
            </Helmet>
            <PageHeader title="Manajemen" />
            <CorporateSectionLayout title="Manajemen" items={items} />
        </>
    );
}

export default ManajemenLayout;
